import { NgModule } from '@angular/core';

import { AudioProjectComponent } from './audio-project.component';
import { AudioProjectFormService } from './audio-project.form';
import { AudioProjectService } from './audio-project.service';

@NgModule({
  imports: [AudioProjectComponent],
  providers: [AudioProjectService, AudioProjectFormService],
  exports: [AudioProjectComponent],
})
export class AudioProjectModule {}
